import React, { useEffect, useRef } from 'react';
import CodeMirror from 'codemirror/lib/codemirror.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/twig/twig';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/addon/runmode/runmode';
import 'codemirror/addon/mode/overlay';

CodeMirror.defineMode(
    'htmltwig',
    (config) =>
        CodeMirror.overlayMode(
            CodeMirror.getMode(config, 'htmlmixed'),
            CodeMirror.getMode(config, 'twig')
        )
);

const CodeMirrorCell = ({ params, field }) => {
    const value = params?.value ?? '';
    const preRef = useRef(null);

    useEffect(() => {
        if (preRef.current) {
            CodeMirror.runMode(
                value,
                field?.options?.mode ?? 'htmltwig',
                preRef.current
            );
        }
    }, [value, field?.options?.mode]);

    return <pre className="multiline-content cm-s-default" ref={preRef} />;
};

export default CodeMirrorCell;
